"use client";

import { useTranslations } from "next-intl";
import { ArrowLeft, Mail, ExternalLink, Shield } from "lucide-react";
import { Link } from "@/i18n/navigation";

export function ContactClient() {
  const t = useTranslations();

  return (
    <div className="w-full max-w-3xl mx-auto px-4 py-8" data-testid="contact-page">
      <Link
        href="/"
        className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors mb-8"
        data-testid="contact-back"
      >
        <ArrowLeft className="w-4 h-4" />
        {t("btn_back")}
      </Link>

      <div className="bg-card border border-border rounded-3xl p-8 md:p-10 card-elevated">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
            <Mail className="w-8 h-8 text-primary" />
          </div>
          <div>
            <h1 className="font-display text-3xl md:text-4xl font-semibold text-foreground">
              {t("contact_title")}
            </h1>
            <p className="text-muted-foreground mt-1">{t("contact_subtitle")}</p>
          </div>
        </div>

        <div className="space-y-8">
          <section>
            <p className="text-foreground/90 leading-relaxed text-lg">
              {t("contact_intro")}
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-semibold text-foreground mb-4">
              {t("contact_social_title")}
            </h2>
            <p className="text-foreground/80 leading-relaxed mb-4">
              {t("contact_social_text")}
            </p>
            <a
              href="https://tr.ee/jow"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-5 py-3 rounded-xl font-medium hover:opacity-90 transition-opacity"
              data-testid="contact-social-link"
            >
              <ExternalLink className="w-4 h-4" />
              {t("contact_social_btn")}
            </a>
          </section>

          <section className="bg-secondary/50 rounded-2xl p-6 border border-border">
            <div className="flex items-start gap-3">
              <Shield className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
              <p className="text-sm text-muted-foreground leading-relaxed">
                {t("contact_privacy_note")}
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
